/** Status das campanhas */
export interface CampanhaStatus {
    id: number;
    nome: string;
    icon: string;
}

export const campanhaStatusNaoConfirmada: CampanhaStatus = {
    id: 1,
    nome: 'Não Confirmada',
    icon: 'fas fa-question'
};

export const campanhaStatusEmAnalise: CampanhaStatus = {
    id: 2,
    nome: 'Em Análise',
    icon: 'fas fa-gavel'
};

export const campanhaStatusReprovada: CampanhaStatus = {
    id: 3,
    nome: 'Reprovada',
    icon: 'far fa-thumbs-down'
};

export const campanhaStatusEmAndamento: CampanhaStatus = {
    id: 4,
    nome: 'Em Andamento',
    icon: 'fas fa-water'
};

export const campanhaStatusEmRevisao: CampanhaStatus = {
    id: 5,
    nome: 'Em Revisão',
    icon: 'fas fa-clipboard-check'
};

export const campanhaStatusEncerrada: CampanhaStatus = {
    id: 6,
    nome: 'Encerrada',
    icon: 'fas fa-check-double'
};

export const campanhaStatuses: CampanhaStatus[] = [
    campanhaStatusNaoConfirmada,
    campanhaStatusEmAnalise,
    campanhaStatusReprovada,
    campanhaStatusEmAndamento,
    campanhaStatusEmRevisao,
    campanhaStatusEncerrada
];

export const campanhaStatusesForm: CampanhaStatus[] = [
    campanhaStatusNaoConfirmada,
    campanhaStatusEmAnalise
]

/** Verifica se o status informado é igual a Não Confirmada */
export function isStatusNaoConfirmada(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === campanhaStatusNaoConfirmada.id;
}


/** Verifica se o status informado é igual a Em Análise */
export function isStatusEmAnalise(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === campanhaStatusEmAnalise.id;
}


/** Verifica se o status informado é igual a Reprovada */
export function isStatusReprovada(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === campanhaStatusReprovada.id;
}


/** Verifica se o status informado é igual a Em Andamento */
export function isStatusEmAndamento(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === campanhaStatusEmAndamento.id;
}

/** Verifica se o status informado é igual a Em Revisão */
export function isStatusEmRevisao(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === campanhaStatusEmRevisao.id;
}


/** Verifica se o status informado é igual a Encerrada */
export function isStatusEncerrada(status: number): boolean {
    if (!status) {
        return false;
    }
    return status === campanhaStatusEncerrada.id;
}

